import { render, staticRenderFns } from "./Wish.vue?vue&type=template&id=5c94b4ed&scoped=true&"
import script from "./Wish.vue?vue&type=script&lang=js&"
export * from "./Wish.vue?vue&type=script&lang=js&"
import style0 from "./Wish.vue?vue&type=style&index=0&id=5c94b4ed&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c94b4ed",
  null
  
)

export default component.exports